import { SEND_2_BANK_WITHDRAWALS } from '../../routes';
import customAxios from "../../customAxios";
import {WithdrawalNamespace} from "../../../types/withdrawal.namespace";

const withdrawalSend2BankOne = async (props: WithdrawalNamespace.propsUpdateOne): Promise<any> => {
  try {
    return (await customAxios.put(SEND_2_BANK_WITHDRAWALS, props)).data;
  } catch (error: unknown) {
    console.error({ SEND_2_BANK_WITHDRAWALS: error });
    return false;
  }
};

export default withdrawalSend2BankOne;
